// React Dependencies
import React, { useState } from 'react';

// External Dependencies
import PropTypes from 'prop-types';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@material-ui/core';
import { toast } from 'react-toastify';

// Internal Dependencies
import ApiService from '../../../services/apiService';
import OverLoading from '../../../components/Loading';
import MText from '../../../components/Common/MText';
import MButton from '../../../components/MButton';
import Colours from '../../../styles/colours';
import { Status, Error } from '../../../common/constants';
import { containerHeaderTextStyle } from '../../../styles/common';

const Context = { Activate: 'Activate', Deactivate: 'Deactivate' };

const ConfirmDeactivateModal = ({ open, pageId, groundStaff, handleReload, handleLimitExceeded, onClose }) => {
  const [isLoading, setIsLoading] = useState(false);

  const isDeactivated = groundStaff.status === Status.Deactivated;

  const onConfirm = async () => {
    try {
      setIsLoading(true);
      await ApiService.updateGroundStaff(pageId, groundStaff.id, { status: (isDeactivated ? Status.Activated : Status.Deactivated) });
      toast.success(`Ground staff has been ${(isDeactivated ? Status.Activated : Status.Deactivated).toLowerCase()}`);
      handleReload();
      onClose();
    } catch (err) {
      if (err.message === Error.MaxNumberGroundStaffs) {
        onClose();
        handleLimitExceeded();
      } else {
        toast.error(err.message);
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth PaperProps={{ style: { padding: '10px 10px 0 10px' } }}>
      {isLoading && <OverLoading />}
      <DialogTitle>
        <MText
          bold
          text={`${(isDeactivated ? Context.Activate : Context.Deactivate)} ground staff ${groundStaff.name}`}
          colour="inherit"
          size={containerHeaderTextStyle.fontSize}
        />
      </DialogTitle>
      <DialogContent>
        <MText
          text={`Are you sure you want to ${(isDeactivated ? Context.Activate : Context.Deactivate).toLowerCase()} this ground staff?`}
          colour="inherit"
          size="14px"
        />
      </DialogContent>
      <DialogActions className="mb-2">
        <MButton
          text={(isDeactivated ? Context.Activate : Context.Deactivate)}
          variant="text"
          className="py-2 px-4"
          textColour={isDeactivated ? Colours.Primary : Colours.Red}
          textStyle={{ fontSize: '14px' }}
          onClick={onConfirm}
        />
        <MButton
          text="Cancel"
          variant="text"
          className="py-2 px-4 mx-1"
          textStyle={{ fontSize: '14px' }}
          onClick={onClose}
        />
      </DialogActions>
    </Dialog>
  );
};

ConfirmDeactivateModal.propTypes = {
  open:                PropTypes.bool,
  pageId:              PropTypes.number.isRequired,
  groundStaff:         PropTypes.shape(Object).isRequired,
  onClose:             PropTypes.func,
  handleReload:        PropTypes.func,
  handleLimitExceeded: PropTypes.func,
};

ConfirmDeactivateModal.defaultProps = {
  open:                false,
  onClose:             () => {},
  handleReload:        () => {},
  handleLimitExceeded: () => {},
};

export default ConfirmDeactivateModal;
